/**
 * LeadRealtimeHook - Handles real-time lead updates with visual feedback and accessibility
 *
 * Features:
 * - Announces lead updates to screen readers via ARIA live region
 * - Highlights newly created or updated leads with a subtle animation
 * - Auto-removes highlight after 3 seconds
 */
export default {
  mounted() {
    // Listen for announcement events from LiveView
    this.handleEvent("announce", ({ message }) => {
      const announcer = document.getElementById("lead-announcements");
      if (announcer) {
        announcer.textContent = message;
        // Clear the message after a brief moment so screen readers don't repeat it
        setTimeout(() => {
          announcer.textContent = "";
        }, 1000);
      }
    });

    // Listen for lead highlight events
    this.handleEvent("highlight-lead", ({ id }) => {
      // Find the lead row by ID
      const leadRow = document.querySelector(`[id*="my_leads-${id}"], [id*="leads-${id}"]`);

      if (leadRow) {
        // Add highlight classes
        leadRow.classList.add("bg-green-50", "ring-2", "ring-green-500", "transition-all", "duration-300");

        // Remove highlight after 3 seconds
        setTimeout(() => {
          leadRow.classList.remove("bg-green-50", "ring-2", "ring-green-500");
          // Keep transition classes for smooth fade out
          setTimeout(() => {
            leadRow.classList.remove("transition-all", "duration-300");
          }, 300);
        }, 3000);
      }
    });
  }
};
